var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"availability-marker",class:_vm.classes,style:(_vm.styles)},[_c('div',{staticClass:"availability-marker__ring",style:({ animationDelay: _vm.animationDelay + 'ms' })}),_c('div',{staticClass:"availability-marker__dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }